export const faqs = [
  {
    question: '嫩小兔玩偶可以机洗吗？',
    answer: '不建议机洗哦！我们推荐手洗保养：使用30℃温水和中性洗涤剂，轻轻按压清洗，不要用力揉搓或拧绞。洗后用干毛巾吸去多余水分，放在通风处自然晾干。避免暴晒、烘干和使用漂白剂。',
  },
  {
    question: '嫩小兔的产品材质安全吗？',
    answer: '所有嫩小兔产品均通过国家玩具安全标准GB6675认证，采用环保安全面料和填充物，无毒无味，适合各个年龄段使用。玩偶系列采用超柔短毛绒，亲肤舒适；周边产品均使用食品级或环保材质。',
  },
  {
    question: '购买后多久可以发货？',
    answer: '现货商品下单后24小时内发货，预售商品根据产品页面标注的发货日期安排发出。默认使用顺丰快递，全国大部分地区2-3天即可送达。',
  },
  {
    question: '嫩小兔有线下实体店吗？',
    answer: '目前我们以线上官方商城为主，但会不定期在全国各大城市举办快闪店活动。关注我们的社交媒体账号（微博、小红书搜索"嫩小兔"），第一时间获取快闪店活动信息！',
  },
  {
    question: '如何辨别真假嫩小兔产品？',
    answer: '正品嫩小兔产品均配有专属防伪标签和唯一编码。您可以通过以下方式辨别：①扫描包装上的防伪二维码验证；②检查产品标签是否含有"嫩小兔"注册商标；③注意玩偶的做工细节，正品缝线工整、面料柔软、颜色自然。请通过官方商城或授权渠道购买，谨防假冒。',
  },
  {
    question: '可以退货或换货吗？',
    answer: '我们支持7天无理由退换货（商品需保持全新状态，包装完整）。如有质量问题，15天内免费换新。具体流程请联系客服，我们会第一时间为您处理。',
  },
];

export const testimonials = [
  {
    id: 't1',
    name: '小糖糖',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20kawaii%20style%20girl%20avatar%20with%20pink%20hair%20and%20big%20sparkly%20eyes%2C%20pastel%20color%20scheme%2C%20flat%20illustration%20style%2C%20clean%20simple%20design&width=120&height=120&seq=avatar-user-01&orientation=squarish',
    content: '从第一眼看到嫩小兔就彻底入坑了！软萌到心化，每次看到它们心情都会变好。已经收集了8只不同造型的了，目标是集齐全系列！',
    rating: 5,
    date: '2026-07-20',
  },
  {
    id: 't2',
    name: '蓝莓奶盖',
    avatar: 'https://readdy.ai/api/search-image?query=A%20kawaii%20style%20girl%20avatar%20with%20blue%20short%20hair%20and%20round%20glasses%2C%20pastel%20color%20scheme%2C%20flat%20illustration%20style%2C%20clean%20simple%20design&width=120&height=120&seq=avatar-user-02&orientation=squarish',
    content: '生日收到了朋友送的嫩小兔生日礼盒，拆开那瞬间感动哭了！兔兔太可爱了，蜡烛和发箍也都超精致，送人真的太有面子了。',
    rating: 5,
    date: '2026-06-18',
  },
  {
    id: 't3',
    name: '草莓布丁',
    avatar: 'https://readdy.ai/api/search-image?query=A%20kawaii%20style%20girl%20avatar%20with%20warm%20brown%20long%20hair%20and%20cute%20smile%2C%20pastel%20color%20scheme%2C%20flat%20illustration%20style%2C%20clean%20simple%20design&width=120&height=120&seq=avatar-user-03&orientation=squarish',
    content: '嫩小兔的质量真的没话说，毛超级软，抱着睡觉特别舒服。盲盒系列也很上头，开出隐藏款的时候开心了一整天！',
    rating: 5,
    date: '2026-05-30',
  },
  {
    id: 't4',
    name: '桃子汽水',
    avatar: 'https://readdy.ai/api/search-image?query=A%20kawaii%20style%20girl%20avatar%20with%20peach%20orange%20hair%20in%20twin%20tails%2C%20pastel%20color%20scheme%2C%20flat%20illustration%20style%2C%20clean%20simple%20design&width=120&height=120&seq=avatar-user-04&orientation=squarish',
    content: '保温杯真的是我的年度爱用！带出门每次都会被问链接。兔耳朵杯盖太戳我了，连喝水都变得有仪式感了。',
    rating: 5,
    date: '2026-04-22',
  },
  {
    id: 't5',
    name: '奶茶啵啵',
    avatar: 'https://readdy.ai/api/search-image?query=A%20kawaii%20style%20girl%20avatar%20with%20soft%20lavender%20hair%20and%20heart%20cheek%20blush%2C%20pastel%20color%20scheme%2C%20flat%20illustration%20style%2C%20clean%20simple%20design&width=120&height=120&seq=avatar-user-05&orientation=squarish',
    content: '联名T恤太好看啦！面料舒服，印花清晰不掉色。和闺蜜一人一件穿出去逛街，回头率超高，已经被好多人问在哪里买了。',
    rating: 5,
    date: '2026-03-15',
  },
];